<template>
	<section class="apply--wrapper bg-gradient--green compact-padding">
		<div class="">
			<div class="container">
				<h2 class="heading heading--lg text-uppercase">
					NO JOB LISTINGS FOR YOU?<br />
					APPLY ANYWAY!
				</h2>

				<p class="paragraph apply__text">
					Exceptional people always have a place at Bohemia
					Interactive — whether your expertise is in programming, art,
					design, animation, testing, publishing, or something else.
					Send us an open application, tell us who you are and what
					you’d like to do, and perhaps there is a job opportunity for
					you, now or in the future. Alternatively, you can also
					subscribe to get notifications for our new job openings!
				</p>
				<div class="button-wrap">
					<basic-button
						class="button-wrap__button"
						size="large"
						tag="router-link"
						to="/open-application"
						type="black"
						>Send Open Application
					</basic-button>
					<basic-button
						class=""
						size="large"
						style="width: fit-content;"
						type="black"
						tag="router-link"
						to="/subscribe"
						>Get Notifications for New Job Openings ->
					</basic-button>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import BasicButton from "./BasicButton";

export default {
	components: { BasicButton },
	name: "ApplyNow"
};
</script>

<style scoped lang="scss">
@import "../assets/scss/globals";
@import "../assets/scss/mixins";

.apply--wrapper {
	background: url("/static/img/backgrounds/Mesh-Terrain.jpg") center no-repeat;
	background-size: cover;
	padding-bottom: 230px;
	padding-top: 160px;

	.heading {
		color: $text-strong;
		line-height: 1.2;
	}

	@media (max-width: $mq-md-max) {
		padding-top: 100px;
		padding-bottom: 100px;
	}

	@media (max-width: $mq-sm-max) {
		.heading {
			br {
				display: none;
			}
		}
	}

	@media (max-width: $mq-xs-max) {
		padding-top: 60px;
		padding-bottom: 45px;
	}
}

.apply__text {
	max-width: 60%;
	margin-top: 40px;
	font-size: 18px;

	@media (max-width: $mq-sm-max) {
		max-width: none;
		font-size: 16px;
	}

	@media (max-width: $mq-xs-max) {
		margin-top: 40px;
	}
}

.button-wrap {
	margin-top: 45px;

	@media (max-width: $mq-xs-max) {
		margin-top: 30px;
		display: flex;
		flex-direction: column;
		align-items: center;

		&__button {
			font-size: 0.95em !important;

			&:not(:last-child) {
				margin-bottom: 15px;
			}
		}
	}
}

.bg-gradient--green {
	height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ApplyNow.vue